module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block2-ee5666280d5d3c98c96a73b040e951a4.png";